import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, AlertTriangle, RefreshCw } from 'lucide-react';
import ClienteForm from '../components/ClienteForm';
import { useToast } from '../components/ToastProvider';
import { clientesAPI, describirError } from '../services/api';
import '../styles/Pages.css';

function ClienteEditar() {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  const [cliente, setCliente] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [errorCarga, setErrorCarga] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [erroresServidor, setErroresServidor] = useState(null);

  const cargar = async () => {
    setCargando(true);
    setErrorCarga(null);
    try {
      const { data } = await clientesAPI.obtener(id);
      setCliente(data);
    } catch (e) {
      setErrorCarga(describirError(e));
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const guardar = async (datos) => {
    setEnviando(true);
    setErroresServidor(null);
    try {
      await clientesAPI.actualizar(id, datos);
      toast.exito('Cambios guardados correctamente');
      navigate(`/clientes/${id}`, { replace: true });
    } catch (e) {
      const err = describirError(e);
      if (err.detalles) {
        setErroresServidor(err.detalles);
        toast.error('Revisa los campos marcados.');
      } else {
        toast.error(err.mensaje);
      }
    } finally {
      setEnviando(false);
    }
  };

  if (cargando) {
    return <div className="page-container"><div className="loading">Cargando cliente…</div></div>;
  }

  if (errorCarga) {
    return (
      <div className="page-container">
        <div className="estado-vacio">
          <span className="estado-vacio-icono is-error">
            <AlertTriangle size={20} strokeWidth={1.75} />
          </span>
          <p className="estado-vacio-titulo">No fue posible cargar el cliente.</p>
          <p className="estado-vacio-texto">{errorCarga.mensaje}</p>
          <button className="btn btn-secondary" onClick={cargar}>
            <RefreshCw size={15} strokeWidth={1.75} />
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <button className="btn btn-ghost volver" onClick={() => navigate(`/clientes/${id}`)}>
        <ArrowLeft size={16} strokeWidth={1.75} />
        Volver al expediente
      </button>

      <p className="editando-a">
        Editando <strong>{cliente.nombreCompleto}</strong> · {cliente.folio}
      </p>

      {/* Mismo componente que el alta: no hay un segundo formulario. */}
      <ClienteForm
        modo="editar"
        valorInicial={cliente}
        enviando={enviando}
        erroresServidor={erroresServidor}
        onSubmit={guardar}
        onCancelar={() => navigate(`/clientes/${id}`)}
      />
    </div>
  );
}

export default ClienteEditar;
